import { BacktestingRunType } from "@shared/types";
import useLiveBacktesting from "@shared/features/bots/BotForm/Backtesting/useLiveBacktesting";
import useStatistics from "@shared/features/bots/BotForm/Backtesting/useStatistics";
import { BacktestingGeneralStatistics } from "@shared/features/bots/BotForm/common/types";

/** The run's net PnL (live while it runs) and its return on the funds. */
const useNetPnl = (run?: BacktestingRunType) => {
  const { liveBacktestingData } = useLiveBacktesting({ data: run });
  const { titleToValue, getChangeValue } = useStatistics({
    backtestingRun: liveBacktestingData,
  });
  return {
    value: Number(titleToValue[BacktestingGeneralStatistics.NET_PNL]) || 0,
    percent: Number(getChangeValue(BacktestingGeneralStatistics.NET_PNL)) || 0,
  };
};

export default useNetPnl;
